__webpack_require__.p = "/mi-assets/mi-static/mi-homepage-renderer/web-rel-26.8.3-082520261600/_next/";